/*
* @author 友人a丶
* @date 
* 
* */

export default {
    "primary-color": '#07c160'
}